export type BaseIdentityAttrs = {
	role: string;
	userDomain: string;
};

export type CustomerIdentityAttrs = BaseIdentityAttrs & {
	selectedCustomerDomain: string;
	selectedCustomerDomainId: string;
};

export type IdentityAttrs = BaseIdentityAttrs | CustomerIdentityAttrs;

export type ErrorIdentityAttrs = Pick<BaseIdentityAttrs, 'userDomain'>;
